import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useEffect, useState } from 'react';
import { CUSTOMER_INFORMATION_STEP, FULFILLMENT_INFORMATION_STEP, PAYMENT_INFORMATION_STEP } from './GuestUserAccordion.constants';
import { getStepsBeingEditedCount, isValidCustomerInformation, isValidFulfillmentInformation } from './GuestUserAccordion.utils';
import CheckoutAccordion from '../../../../../../domains/checkout/CheckoutAccordion';
import CustomerInformationDisplay from '../../../../../../domains/checkout/CustomerInformationDisplay';
import FulfillmentInformationDisplay from '../../../../../../domains/checkout/FulfillmentInformationDisplay';
import PaymentMethodDisplay from '../../../../../../domains/checkout/PaymentMethodDisplay';
import { CUSTOMER_KEY, FULFILLMENT_KEY, PAYMENT_SOURCE_KEY } from '../../../../../../hooks/use-checkout/use-checkout.constants';
import { getFulfillmentProviderForOrder } from '../../../../../../modules/fulfillment/services/order';
import { getOrderSubtotal } from '../../../../../../services/checkout/order';
import CustomerInformationForm from '../../../../../CustomerInformationForm';
import FulfillmentInformationForm from '../../../../../FulfillmentInformationForm';
import { CheckoutContext } from '../../../../Checkout.context';
import StripePaymentSourceForm from '../StripePaymentSourceForm';
import './GuestUserAccordion.css';
var defaultProps = {
  reviewingOrder: false
};
export default function GuestUserAccordion(_ref) {
  var onReviewOrder = _ref.onReviewOrder,
    reviewingOrder = _ref.reviewingOrder;
  var _useContext = useContext(CheckoutContext),
    checkout = _useContext.checkout;
  var onCheckoutDataChange = checkout.onCheckoutDataChange,
    _checkout$checkoutDat = checkout.checkoutData,
    checkoutData = _checkout$checkoutDat === void 0 ? {} : _checkout$checkoutDat,
    setEditingCheckoutData = checkout.setEditingCheckoutData,
    checkoutLoading = checkout.checkoutLoading,
    updateOrderCustomer = checkout.updateOrderCustomer,
    updateOrderFulfillment = checkout.updateOrderFulfillment,
    updateOrderFulfillmentRecipient = checkout.updateOrderFulfillmentRecipient,
    setOrderPaymentSource = checkout.setOrderPaymentSource,
    order = checkout.order;
  var subTotal = getOrderSubtotal(order);
  var orderAmountIsZero = subTotal === 0;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    activeStep = _useState2[0],
    setActiveStep = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    stepsBeingEdited = _useState4[0],
    setStepsBeingEdited = _useState4[1];
  var _checkoutData$fulfill = checkoutData.fulfillment,
    fulfillment = _checkoutData$fulfill === void 0 ? {} : _checkoutData$fulfill,
    _checkoutData$payment = checkoutData.paymentSource,
    paymentSource = _checkoutData$payment === void 0 ? {} : _checkoutData$payment,
    _checkoutData$custome = checkoutData.customer,
    customer = _checkoutData$custome === void 0 ? {} : _checkoutData$custome;
  var _customer$firstName = customer.firstName,
    firstName = _customer$firstName === void 0 ? '' : _customer$firstName,
    _customer$lastName = customer.lastName,
    lastName = _customer$lastName === void 0 ? '' : _customer$lastName,
    _customer$email = customer.email,
    email = _customer$email === void 0 ? '' : _customer$email,
    _customer$phoneNumber = customer.phoneNumber,
    phoneNumber = _customer$phoneNumber === void 0 ? '' : _customer$phoneNumber;
  var _fulfillment$firstNam = fulfillment.firstName,
    fulfillmentFirstName = _fulfillment$firstNam === void 0 ? firstName : _fulfillment$firstNam,
    _fulfillment$lastName = fulfillment.lastName,
    fulfillmentLastName = _fulfillment$lastName === void 0 ? lastName : _fulfillment$lastName,
    _fulfillment$country = fulfillment.country,
    country = _fulfillment$country === void 0 ? '' : _fulfillment$country,
    _fulfillment$state = fulfillment.state,
    state = _fulfillment$state === void 0 ? '' : _fulfillment$state,
    _fulfillment$city = fulfillment.city,
    city = _fulfillment$city === void 0 ? '' : _fulfillment$city,
    _fulfillment$postalCo = fulfillment.postalCode,
    postalCode = _fulfillment$postalCo === void 0 ? '' : _fulfillment$postalCo,
    _fulfillment$line = fulfillment.line1,
    line1 = _fulfillment$line === void 0 ? '' : _fulfillment$line,
    _fulfillment$line2 = fulfillment.line2,
    line2 = _fulfillment$line2 === void 0 ? '' : _fulfillment$line2,
    fulfillmentType = fulfillment.fulfillmentType;
  var _useState5 = useState(getFulfillmentProviderForOrder(order, fulfillmentType)),
    _useState6 = _slicedToArray(_useState5, 2),
    fulfillmentProvider = _useState6[0],
    setFulfillmentProvider = _useState6[1];
  var _paymentSource$card = paymentSource.card,
    _paymentSource$card2 = _paymentSource$card === void 0 ? {} : _paymentSource$card,
    _paymentSource$card2$ = _paymentSource$card2.last4,
    last4 = _paymentSource$card2$ === void 0 ? '' : _paymentSource$card2$,
    _paymentSource$card2$2 = _paymentSource$card2.brand,
    brand = _paymentSource$card2$2 === void 0 ? '' : _paymentSource$card2$2;
  useEffect(function () {
    var count = getStepsBeingEditedCount(stepsBeingEdited);
    setEditingCheckoutData(count > 0);
  }, [stepsBeingEdited]);
  useEffect(function () {
    setFulfillmentProvider(getFulfillmentProviderForOrder(order, fulfillmentType));
  }, [fulfillmentType]);
  function editStepOn(stepNumber) {
    setStepsBeingEdited(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, stepNumber, true));
    });
  }
  function editStepOff(stepNumber) {
    setStepsBeingEdited(function (previousState) {
      return _objectSpread(_objectSpread({}, previousState), {}, _defineProperty({}, stepNumber, false));
    });
  }
  function onPaneClick(stepNumber) {
    if (reviewingOrder) {
      editStepOn(stepNumber);
    } else {
      if (stepNumber >= activeStep) {
        // don't let the user move forward before filling current step information
        return;
      }
      setActiveStep(stepNumber);
    }
  }
  function moveToNextStep() {
    // eslint-disable-next-line no-use-before-define
    if (activeStep === panes.length) {
      onReviewOrder();
    } else {
      setActiveStep(function (prevState) {
        return prevState + 1;
      });
    }
  }
  function onTokenCreated() {
    return _onTokenCreated.apply(this, arguments);
  }
  function _onTokenCreated() {
    _onTokenCreated = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref7,
        tokenId,
        card,
        type,
        token,
        _args4 = arguments;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _ref7 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, tokenId = _ref7.tokenId, card = _ref7.card, type = _ref7.type;
            token = {
              token: tokenId,
              savePaymentSource: false,
              card: card,
              type: type
            };
            _context4.prev = 2;
            onCheckoutDataChange({
              value: token,
              name: PAYMENT_SOURCE_KEY
            });
            _context4.next = 6;
            return setOrderPaymentSource(token);
          case 6:
            if (stepsBeingEdited[PAYMENT_INFORMATION_STEP]) {
              editStepOff(PAYMENT_INFORMATION_STEP);
            } else {
              moveToNextStep();
            }
            _context4.next = 11;
            break;
          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](2);
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 9]]);
    }));
    return _onTokenCreated.apply(this, arguments);
  }
  function onFulfillmentFormChange(_x) {
    return _onFulfillmentFormChange.apply(this, arguments);
  }
  function _onFulfillmentFormChange() {
    _onFulfillmentFormChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(newData) {
      var newFulfillmentType;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            onCheckoutDataChange({
              name: FULFILLMENT_KEY,
              value: _objectSpread(_objectSpread({}, fulfillment), newData)
            });
            newFulfillmentType = newData.fulfillmentType;
            if (!newFulfillmentType) {
              _context5.next = 5;
              break;
            }
            _context5.next = 5;
            return updateOrderFulfillment(newFulfillmentType);
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _onFulfillmentFormChange.apply(this, arguments);
  }
  function onNextFulfillmentInformation() {
    return _onNextFulfillmentInformation.apply(this, arguments);
  }
  function _onNextFulfillmentInformation() {
    _onNextFulfillmentInformation = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return updateOrderFulfillment();
          case 2:
            _context6.next = 4;
            return updateOrderFulfillmentRecipient();
          case 4:
            if (reviewingOrder) {
              // make sure the user is forced to re input payment information
              editStepOn(PAYMENT_INFORMATION_STEP);
            }
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _onNextFulfillmentInformation.apply(this, arguments);
  }
  function onCustomerFormChange(e, _ref2) {
    var name = _ref2.name,
      value = _ref2.value;
    var newData = _defineProperty({}, name, value);
    onCheckoutDataChange({
      name: CUSTOMER_KEY,
      value: _objectSpread(_objectSpread({}, customer), newData)
    });
    if (['firstName', 'lastName'].includes(name) && !reviewingOrder) {
      onFulfillmentFormChange(_defineProperty({}, name, value));
    }
  }
  function getOnNextClickForStep(stepNumber) {
    var callbackFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", null);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    if (!reviewingOrder) {
      return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return callbackFunction();
            case 3:
              moveToNextStep();
              _context2.next = 8;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 6]]);
      }));
    }
    if (stepsBeingEdited[stepNumber]) {
      return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return callbackFunction();
            case 3:
              editStepOff(stepNumber);
              _context3.next = 8;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 6]]);
      }));
    }
    return null;
  }
  function getPaneIconName(stepNumber) {
    if (stepsBeingEdited[stepNumber]) {
      return null;
    }
    if (reviewingOrder) {
      return 'pencil';
    }
    return stepNumber < activeStep ? 'check circle' : null;
  }
  var panes = [{
    stepNumber: CUSTOMER_INFORMATION_STEP,
    title: 'Customer Information',
    content: reviewingOrder && !stepsBeingEdited[CUSTOMER_INFORMATION_STEP] ? /*#__PURE__*/React.createElement(CustomerInformationDisplay, {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phoneNumber: phoneNumber
    }) : /*#__PURE__*/React.createElement(CustomerInformationForm, {
      email: {
        value: email,
        required: true
      },
      phoneNumber: {
        value: phoneNumber,
        required: true
      },
      firstName: {
        value: firstName,
        required: true
      },
      lastName: {
        value: lastName,
        required: true
      },
      onChange: onCustomerFormChange
    }),
    onNextClick: getOnNextClickForStep(CUSTOMER_INFORMATION_STEP, updateOrderCustomer),
    disableNextButton: !isValidCustomerInformation(customer)
  }, {
    className: 'fulfillment-information',
    stepNumber: FULFILLMENT_INFORMATION_STEP,
    title: /*#__PURE__*/React.createElement("div", {
      className: "fulfillment-information-title-container"
    }, /*#__PURE__*/React.createElement("div", null, "Fulfillment Information")),
    content: reviewingOrder && !stepsBeingEdited[FULFILLMENT_INFORMATION_STEP] ? /*#__PURE__*/React.createElement(FulfillmentInformationDisplay, {
      firstName: fulfillmentFirstName,
      lastName: fulfillmentLastName,
      line1: line1,
      state: state,
      postalCode: postalCode,
      country: country
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FulfillmentInformationForm, {
      order: order,
      firstName: fulfillmentFirstName,
      lastName: fulfillmentLastName,
      country: country,
      state: state,
      city: city,
      postalCode: postalCode,
      line1: line1,
      line2: line2,
      fulfillmentMethod: {
        fulfillmentType: fulfillmentType,
        fulfillmentProvider: fulfillmentProvider
      },
      defaultEnterManualAddress: reviewingOrder,
      onChange: onFulfillmentFormChange,
      showCountryInput: false
    })),
    onNextClick: getOnNextClickForStep(FULFILLMENT_INFORMATION_STEP, onNextFulfillmentInformation),
    disableNextButton: !isValidFulfillmentInformation(fulfillment)
  }, {
    className: 'payment-method',
    stepNumber: PAYMENT_INFORMATION_STEP,
    title: 'Payment Method',
    content: reviewingOrder && !stepsBeingEdited[PAYMENT_INFORMATION_STEP] ? /*#__PURE__*/React.createElement(PaymentMethodDisplay, {
      last4: last4,
      type: brand
    }) : /*#__PURE__*/React.createElement(StripePaymentSourceForm, {
      disabled: orderAmountIsZero,
      onTokenCreated: onTokenCreated,
      isGuestUser: true,
      submitButtonText: stepsBeingEdited[PAYMENT_INFORMATION_STEP] ? 'SAVE' : 'REVIEW ORDER'
    })
  }];
  return /*#__PURE__*/React.createElement(CheckoutAccordion, {
    className: "guest-user-accordion"
  }, panes.map(function (_ref6) {
    var stepNumber = _ref6.stepNumber,
      title = _ref6.title,
      content = _ref6.content,
      onNextClick = _ref6.onNextClick,
      _ref6$disableNextButt = _ref6.disableNextButton,
      disableNextButton = _ref6$disableNextButt === void 0 ? false : _ref6$disableNextButt,
      className = _ref6.className;
    return /*#__PURE__*/React.createElement(CheckoutAccordion.Pane, {
      key: stepNumber,
      stepNumber: stepNumber,
      title: title,
      active: activeStep === stepNumber || reviewingOrder,
      disabled: stepNumber > activeStep,
      iconName: getPaneIconName(stepNumber),
      onClick: function onClick() {
        onPaneClick(stepNumber);
      },
      onNextClick: onNextClick,
      nextButtonText: stepsBeingEdited[stepNumber] ? 'SAVE' : 'NEXT',
      disableNextButton: disableNextButton || checkoutLoading,
      className: className
    }, content);
  }));
}
GuestUserAccordion.defaultProps = defaultProps;